import {FREE_TRIAL_STORE_NAME} from '../reducers/reducers'

export function getFreeTrialApplication(state) {
    const { freeTrialApplicationSubmissionSuccess, freeTrialApplicationSubmissionError, freeTrialActivated }  = state[FREE_TRIAL_STORE_NAME] || { }
    return { freeTrialApplicationSubmissionSuccess, freeTrialApplicationSubmissionError, freeTrialActivated }
}
